import {
  Box,
  Divider,
  Link,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import { useRef, useState } from "react";
import { styled } from "@mui/material/styles";
import { getColorForIndex } from "../../utilities";
import CartQuantityButtons from "../../components/common/CartQuantityButtons";
import PrintingCakePreviewDialog from "./PrintingCakePreviewDialog";
import BulkProductUpdateModal from "./BulkProductUpdateModal";

function CartItem({
  isLoading,
  cartLength,
  index,
  cart,
  updateCartQtyMutate,
  updateBulkQtyMutate,
}) {
  const dialogRef = useRef(null);

  const [quantity, setQuantity] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [modalType, setModalType] = useState("");

  const isBulkProduct = cart?.is_bulk_product > 0 ? true : false;
  const discountPrice = cart.product_discount_price * +cart.product_quantity;
  // const originalPrice = cart.product_price * +cart.product_quantity;
  const originalPrice = cart.product_price * +cart.product_quantity;

  const handlePreviewDialog = () => dialogRef.current?.openDialog();
  const modifyHandler = () => {
    setModalType("UPDATE");
    setIsOpen(true);
  };

  // ✅ added
  const deleteHandler = () => {
    setModalType("REMOVE");
    setIsOpen(true);
  };

  const handleBulkQuantity = (modalQty, currentType) => {
    setIsOpen(false);
    const qty = Number(modalQty);

    if (isNaN(qty)) return;

    if (
      qty >= (cart?.bulk_price?.min_quantity || 0) ||
      currentType === "REMOVE"
    ) {
      updateBulkQtyMutate({
        cartId: cart?.cart_id,
        qty,
        customerId: cart?.customer_id,
        weightId: cart?.variations?.weight_id,
      });
    } else {
      console.warn("Quantity below minimum:", cart?.bulk_price?.min_quantity);
    }
  };
  return (
    <>
      <Box
        display={"flex"}
        flexDirection={"row"}
        gap={3}
        key={index}
        sx={{
          border: "1px solid rgba(183, 124, 10, 0.2)",
          borderRadius: "14px",
          background:
            "linear-gradient(180deg, rgba(255,255,255,0.97) 0%, rgba(255,250,242,0.82) 100%)",
          p: { xs: 1.2, sm: 1.5 },
        }}
      >
        {isLoading ? (
          <Skeleton
            variant="rectangular"
            width={"140px"}
            height="130px"
            sx={{ borderRadius: 1 }}
          />
        ) : (
          <>
            <Box sx={{ position: "relative", flexShrink: 0 }}>
              <CartImage
                src={cart?.products?.app_image?.app_product_image}
                alt={cart?.products?.product_name}
              />
            </Box>
          </>
        )}
        <Box
          sx={{
            gap: 1,
            display: "flex",
            flexDirection: "column",
            width: "100%",
            minWidth: 0,
          }}
        >
          {isLoading ? (
            <Skeleton
              variant="text"
              width={"40%"}
              height="40px"
              sx={{ borderRadius: 1 }}
            />
          ) : (
            <CakeName>{cart?.products?.product_name}</CakeName>
          )}
          {isLoading ? (
            <Box sx={{ display: "flex", flexDirection: "row", gap: 3 }}>
              <Skeleton
                variant="text"
                width={"10%"}
                height="24px"
                sx={{ borderRadius: 1 }}
              />
              <Skeleton
                variant="text"
                width={"10%"}
                height="24px"
                sx={{ borderRadius: 1 }}
              />
            </Box>
          ) : (
            <Stack
              direction="row"
              spacing={1}
              useFlexGap
              sx={{
                justifyContent: "left",
                color: "text.secondary",
                alignItems: "center",
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 500,
                  fontSize: "14px",
                  color: "var(--neutral-500)",
                  textAlign: "left",
                  lineHeight: "157%",
                }}
              >
                {cart?.variations?.weight[0]?.weight_name} &nbsp;
                {cart?.products?.unit?.unit_name}
              </Typography>
              {cart?.parent_id > 0 && <ComboTag />}

              {/* <Circle size={6} weight="fill" />

              <Typography
                variant="h3"
                sx={{
                  fontWeight: 500,
                  fontSize: "14px",
                  color: "var(--neutral-500)",
                  textAlign: "left",
                  lineHeight: "157%",
                }}
              >
                {cart?.flavour?.flavour_name}
              </Typography> */}
            </Stack>
          )}

          <Stack direction="row" spacing={2} alignItems={"center"}>
            {isLoading ? (
              <Skeleton
                variant="text"
                width={"20%"}
                height="30px"
                sx={{ borderRadius: 1 }}
              />
            ) : (
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 600,
                  fontSize: "16px",
                  lineHeight: "150%",
                  color: "var(--neutral-black)",
                  textAlign: "left",
                }}
              >
                ₹ {discountPrice}
              </Typography>
            )}

            {!isBulkProduct && discountPrice != originalPrice && (
              <>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 400,
                    fontSize: "16px",
                    lineHeight: "150%",
                    color: "var(--neutral-700)",
                    textAlign: "left",
                    textDecoration: "line-through",
                  }}
                >
                  ₹ {originalPrice}
                </Typography>
              </>
            )}
            {cart?.variations?.discountPercent > 0 && (
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 500,
                  fontSize: "12px",
                  lineHeight: "133%",
                  color: "#0cb67b",
                  textAlign: "center",
                  padding: "4px 12px",
                  backgroundColor: "rgba(8, 177, 118, 0.1)",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  marginTop: "4px !important",
                  marginBottom: "4px !important",
                }}
              >
                {cart?.variations?.discountPercent}% Off
              </Typography>
            )}
            {+cart?.products?.shape_id > 0 &&
              cart?.products?.photo_cakes_images?.[0]?.photo_cake_image && (
                <Link
                  component="button"
                  variant="body2"
                  sx={{ fontWeight: 600, fontSize: "14px" }}
                  onClick={handlePreviewDialog}
                >
                  View print file
                </Link>
              )}
          </Stack>
          {isLoading ? (
            <Stack direction="row" spacing={2} alignItems={"center"}>
              <Skeleton
                variant="rectangular"
                width={24}
                height={24}
                sx={{ borderRadius: 1 }}
              />
              <Skeleton
                variant="rectangular"
                width={24}
                height={24}
                sx={{ borderRadius: 1 }}
              />
              <Skeleton
                variant="rectangular"
                width={24}
                height={24}
                sx={{ borderRadius: 1 }}
              />
            </Stack>
          ) : (
            <Box
              display={"flex"}
              justifyContent={"space-between"}
              alignItems={"center"}
              sx={{
                flexDirection: { xs: "column", md: "row" },
                gap: { xs: 1, md: 0 },
              }}
            >
              {/* ✅ Hide CartQuantityButtons for bulk, show qty + Modify + Remove instead */}
              {isBulkProduct && (
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "14px",
                      color: "var(--neutral-black)",
                    }}
                  >
                    Qty: {cart?.product_quantity}
                  </Typography>
                  <Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />
                  <Link
                    component="button"
                    variant="body2"
                    sx={{
                      fontWeight: 500,
                      fontSize: "13px",
                      color: "#FF272F",
                      textDecorationColor: "#FF272F",
                    }}
                    onClick={modifyHandler}
                  >
                    Modify
                  </Link>
                  <Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />
                  <Link
                    component="button"
                    variant="body2"
                    sx={{
                      fontWeight: 500,
                      fontSize: "13px",
                      color: "#FF272F",
                      textDecorationColor: "#FF272F",
                    }}
                    onClick={deleteHandler}
                  >
                    Remove
                  </Link>
                </Stack>
              )}
              {!isBulkProduct && (
                <CartQuantityButtons
                  updateCartQtyMutate={updateCartQtyMutate}
                  cartId={cart?.cart_id}
                  customerId={cart?.customer_id}
                  currentQty={cart?.product_quantity}
                />
              )}
            </Box>
          )}
        </Box>
      </Box>
      {index !== cartLength - 1 && <Divider variant="middle" sx={{ my: 3 }} />}
      <PrintingCakePreviewDialog
        ref={dialogRef}
        uploadedImage={
          cart?.products?.photo_cakes_images?.[0]?.photo_cake_image
        }
      />
      <BulkProductUpdateModal
        type={modalType}
        open={isOpen}
        setOpen={setIsOpen}
        handleBulkQuantity={handleBulkQuantity}
        minQty={cart?.bulk_price?.min_quantity || 0}
      />
    </>
  );
}

const CartImage = styled("img")(({ theme, index }) => ({
  backgroundColor: getColorForIndex(index),
  textAlign: "center",
  width: "144px",
  //   height: "144px",
  borderRadius: "8px",
  cursor: "pointer",
  [theme.breakpoints.down("sm")]: {
    width: "80px !important",
    height: "80px !important",
    objectFit: "contain",
  },
}));
const ComboTag = () => {
  const StyledComboTag = styled("span")(({ theme }) => ({
    backgroundColor: "#dc2626",
    height: "auto",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "0.65rem",
    padding: "0.2rem 0.5rem",
    borderRadius: "0.375rem",
    boxShadow:
      "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    display: "inline-block",
    userSelect: "none",
  }));

  return <StyledComboTag>COMBO</StyledComboTag>;
};
const CakeName = styled("h3")(({ theme }) => ({
  margin: 0,
  fontWeight: 700,
  fontSize: "17px",
  lineHeight: "150%",
  color: "#2C2418",
  textAlign: "left",
  textTransform: "capitalize",
  // whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",

  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",

  [theme.breakpoints.down("sm")]: {
    fontSize: "14px !important",
  },
}));
export default CartItem;
